import NuKenzieBlack from "../../../../assets/img/NuKenzieBlack.svg";
export const Logo = () => {
  return <img src={NuKenzieBlack} />;
};
